import React from 'react'
import { Link } from 'react-router-dom'

import { useI18N } from '../../../libraries/i18n/hook'

type Source = { content_type: string, id: number, title: string }
type AnswerProps = { sources: string }
const AnswerSources: React.FC<AnswerProps> = ({ sources }) => {
  const { t } = useI18N()
  const sourceJson = JSON.parse(sources)
  const renderLink = (source: Source) => {
    if(source.content_type === 'document') {
      return <Link to={`/content/documents/${source.id}`}>{source.title}</Link>
    } else if(source.content_type === 'video') {
      return <Link to={`/content/videos/${source.id}`}>{source.title}</Link>
    } else {
      return <span>{source.title}</span>
    }
  }

  return (
    <div className='pt-2'>
      <b>{t('advisor.sources')}:</b>
      <div className='grid'>
        {sourceJson.map((source: Source, i: number) => (
          <div key={`source${i}`} className='truncate text-ellipsis'>[{i+1}]: <b>{renderLink(source)}</b></div>
        ))}
      </div>
    </div>
  )
}

export default AnswerSources
